module.exports = __webpack_public_path__ + "img/news_02.9ccd5cdc.jpg";